/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable consistent-return */
import {
  Button,
  CircularProgress,
  IconButton,
  Paper,
  makeStyles,
} from '@material-ui/core';
import Popup from 'reactjs-popup';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import React, { useState } from 'react';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import VisibilityIcon from '@material-ui/icons/Visibility';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CircleIcon from '@material-ui/icons/FiberManualRecord';
import moment from 'moment';
import FeatureFlagEmptyState from '../../Components/FeatureFlagEmptyState';
import { mappedCurrentActiveRole } from '../../../utils/roleMapping';
import {
  deleteFileHandlerNew,
  getViewURLNew,
} from '../../../utils/fileUploadHandler';
import logger from '../../../utils/logger';

const contentStyle = { width: '300px' };
const inlineCheckIconStyle = {
  color: '#52BE56',
};
const useStyles = makeStyles(theme => ({
  paper: { padding: 10, marginTop: 10 },
  viewButton: {
    background: '#52BE56',
    color: 'white',
    margin: '0px 10px 0px 0px',
    padding: '5px 10px',
  },
  viewCardMeta: {
    display: 'flex',
    margin: '10px 0px 0px 8px',
    gap: '5px',
    alignItems: 'center',
  },
  deleteModalButton: {
    width: '45%',
    background: '#52BE56',
    borderRadius: 0,
    color: 'white',
    margin: '5px',
  },
  cancelButton: {
    width: '45%',
    background: 'lightgray',
    borderRadius: 0,
    margin: '5px',
  },
}));
const TruckerTDS = ({
  activeRole,
  stylesClass,
  truckerId,
  featureFlagFiles,
  fileDetails,
  refetch,
}) => {
  const {
    tds_declaration_file_path: isTdsAvailable,
    pan_uploaded_by: uploadedBy,
    tds_uploaded_at: uploadedAt,
  } = fileDetails || {};
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [isDeleting, setIsDeleting] = React.useState(false);

  const truckerTDSUrl = async () => {
    setLoading(true);
    const viewURLBody = {
      role: mappedCurrentActiveRole(activeRole),
      file_type: 'trucker_tds',
      trucker_id: truckerId,
    };
    getViewURLNew(viewURLBody)
      .then(result => {
        window.open(result?.data?.file_details?.url);
        setLoading(false);
      })
      .catch(e => {
        logger.error(e);
        setLoading(false);
      });
  };

  async function deleteFIleUploaded() {
    setIsDeleting(true);
    const body = {
      scope: 'trucker',
      file_type: 'TDS',
      org_id: truckerId,
      role: mappedCurrentActiveRole(activeRole),
    };

    try {
      await deleteFileHandlerNew(body);
      setIsDeleting(false);
      refetch();
    } catch (e) {
      logger.error(e);
      setIsDeleting(false);
    }
  }
  return (
    <Paper className={classes.paper}>
      {featureFlagFiles === 1 ? (
        <FeatureFlagEmptyState color="black" />
      ) : (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
          }}
        >
          <div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <p
                style={{
                  textAlign: 'left',
                  fontSize: '20px',
                  fontWeight: 400,
                  margin: '8px',
                }}
              >
                Trucker TDS
              </p>
              {isTdsAvailable && (
                <CheckCircleIcon
                  style={inlineCheckIconStyle}
                  fontSize="small"
                />
              )}
            </div>
            {isTdsAvailable && (
              <div className={classes.viewCardMeta}>
                <p
                  style={{
                    fontWeight: 'bold',
                    fontSize: '12px',
                    margin: 0,
                  }}
                >
                  {uploadedBy}
                </p>
                <CircleIcon style={{ fontSize: '10px' }} />
                <p
                  style={{
                    color: '#a9a9a9',
                    fontSize: '10px',
                    margin: 0,
                  }}
                >
                  {moment(uploadedAt).format('LLL')}
                </p>
              </div>
            )}
            {!isTdsAvailable && (
              <div>
                <p style={{ margin: '0 0 10px 8px' }}>No File Uploaded </p>
              </div>
            )}
          </div>

          {isTdsAvailable && (
            <div>
              <div>
                <div>
                  <Button
                    variant="contained"
                    color="success"
                    size="small"
                    className={classes.viewButton}
                    onClick={() => truckerTDSUrl()}
                    startIcon={<VisibilityIcon />}
                    disabled={loading}
                  >
                    View {loading && <CircularProgress size={8} />}
                  </Button>
                  {(activeRole === 'ops' || activeRole === 'approval') && (
                    <Popup
                      trigger={
                        isDeleting ? (
                          <CircularProgress
                            style={{ color: '#FCD21F', margin: '5px' }}
                            size={30}
                            thickness={8}
                          />
                        ) : (
                          <IconButton
                            color="primary"
                            aria-label="upload picture"
                            component="span"
                            size="small"
                          >
                            <DeleteOutlineIcon color="error" />
                          </IconButton>
                        )
                      }
                      {...{
                        contentStyle,
                      }}
                      modal
                    >
                      {close => (
                        <div
                          style={{
                            padding: '10px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                          }}
                        >
                          <HighlightOffIcon fontSize="large" color="error" />

                          <h4 style={{ fontWeight: 'bold' }}>Are You Sure?</h4>
                          <p>
                            If you proceed, you will not be able to recover it
                          </p>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              width: '100%',
                            }}
                          >
                            <Button
                              onClick={close}
                              className={classes.cancelButton}
                            >
                              No
                            </Button>

                            <Button
                              onClick={() => {
                                close();
                                deleteFIleUploaded();
                              }}
                              className={classes.deleteModalButton}
                            >
                              Yes
                            </Button>
                          </div>
                        </div>
                      )}
                    </Popup>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </Paper>
  );
};

export default TruckerTDS;
